export const AssingTailor_REQUEST = "AssingTailor_REQUEST";
export const AssingTailor_SUCCESS = "AssingTailor_SUCCESS";
export const AssingTailor_FAIL = "AssingTailor_FAIL";

export const GetAllAssignment_REQUEST = "GetAllAssignment_REQUEST";
export const GetAllAssignment_SUCCESS = "GetAllAssignment_SUCCESS";
export const GetAllAssignment_FAIL = "GetAllAssignment_FAIL";

export const AssingmentStatusUpdate_REQUEST = "AssingmentStatusUpdate_REQUEST";
export const AssingmentStatusUpdate_SUCCESS = "AssingmentStatusUpdate_SUCCESS";
export const AssingmentStatusUpdate_FAIL = "AssingmentStatusUpdate_FAIL";